// extracted by mini-css-extract-plugin
export default {"total":"footer_total_total__6fyvF","textBlockRow":"footer_total_textBlockRow__p1EU-"};